import React from 'react';
import PropTypes from 'prop-types';
import orderBy from 'lodash/orderBy';
import {Stack, ProgressBar, Button, TextStyle} from '@shopify/polaris';
import {StarRating} from 'components/polaris/react/star-rating';

export const Classes = {
  container: 'star-rating-aggregate',
  item: 'star-rating-aggregate__item',
};

export class StarRatingAggregate extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleOnSelectRating = this.handleOnSelectRating.bind(this);
  }

  render() {
    const sorted = sortAggregates(this.props.aggregates);
    const total = calculateTotalRatings(this.props.aggregates);

    return (
      <Stack spacing="tight">
        <Stack.Item>
          {sorted.map(context => (
            <div className={Classes.item} key={`star-${context.value}`}>
              <StarRating value={context.value} readOnly />
            </div>
          ))}
        </Stack.Item>

        <Stack.Item fill>
          {sorted.map(context => (
            <div className={Classes.item} key={`bar-${context.value}`}>
              <ProgressBar progress={calculateProgress(context.count, total)} />
            </div>
          ))}
        </Stack.Item>

        <Stack.Item>
          {sorted.map(context => (
            <div className={Classes.item} key={`count-${context.value}`}>
              {this.props.onSelectRating && context.count > 0 ? (
                <Filter
                  value={context.value}
                  count={context.count}
                  onClick={this.handleOnSelectRating}
                />
              ) : (
                <TextStyle variation="subdued">({context.count})</TextStyle>
              )}
            </div>
          ))}
        </Stack.Item>
      </Stack>
    );
  }

  handleOnSelectRating(evt) {
    this.props.onSelectRating(evt);
  }
}

StarRatingAggregate.propTypes = {
  aggregates: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      count: PropTypes.number.isRequired,
    })
  ).isRequired,
  onSelectRating: PropTypes.func,
};

class Filter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  render() {
    return (
      <Button onClick={this.handleOnClick} plain>
        ({this.props.count})
      </Button>
    );
  }

  handleOnClick() {
    this.props.onClick(this.props.value);
  }
}

Filter.propTypes = {
  count: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

function sortAggregates(aggregates) {
  return orderBy(aggregates, ['value'], ['desc']);
}

function calculateTotalRatings(aggregates) {
  return aggregates.reduce((sum, aggregate) => {
    return sum + aggregate.count;
  }, 0);
}

function calculateProgress(count, total) {
  return (count / total) * 100 || 0;
}
